import { render, staticRenderFns } from "./pie-charge-detail.vue?vue&type=template&id=537e0b79&scoped=true"
import script from "./pie-charge-detail.vue?vue&type=script&lang=js"
export * from "./pie-charge-detail.vue?vue&type=script&lang=js"
import style0 from "./pie-charge-detail.vue?vue&type=style&index=0&id=537e0b79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537e0b79",
  null
  
)

export default component.exports